<template lang="pug">
.floating-chat.enter(:class="chatClass", @click="handleContainerClick", v-if="showDialog")
  inline-svg.ai-icon(v-show="!isExpanded", :src="require('../../../assets/icons/ai/notification-message.svg')")

  chat-component(:permitted="showDialog", :paths="liteChatPaths", :is-lite="true", v-if="isReady")
    template(v-slot:header)
      .img
      .text Amelia
      button(@click="closeElement")
        i.fa.fa-times(aria-hidden="true")
</template>

<script setup>
import { ref, computed } from "vue";

import ChatComponent from "../components/chat.vue";

const liteChatPaths = { main: "api/v3/ai/chats/", name: "lite" };

const props = defineProps({
  /* объект, содержащий пермишны для агента, нужный нам ключ - ai_lite_agent */
  aiPermissions: { type: Object, default: null },
});

const isExpanded = ref(false);
const isReady = ref(false);

const showDialog = computed(() => props.aiPermissions?.ai_lite_agent);
const chatClass = computed(() => ({ expand: isExpanded.value }));

const handleContainerClick = () => {
  if (!isExpanded.value) {
    openElement();
  }
};

const openElement = () => {
  isExpanded.value = true;
  setTimeout(() => (isReady.value = true), 200);
};

const closeElement = async e => {
  e.stopPropagation();

  isReady.value = false;
  isExpanded.value = false;
};
</script>

<style lang="scss" scoped>
.floating-chat {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 64px;
  height: 64px;
  transform: translateY(70px);
  transition: all 250ms ease-out;
  border-radius: 50%;
  opacity: 0;
  z-index: 100;
  background: url("../../../assets/images/ai_chat_background.png");

  &.enter:hover {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    opacity: 1;
  }

  &.enter {
    transform: translateY(0);
    opacity: 1;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.14);
    background-size: cover;
  }

  &.expand {
    border-radius: 5px;
    cursor: auto;
    opacity: 1;
    height: calc(100% - 48px);
    bottom: 24px;
    right: 24px;
    border-radius: 32px;
    width: 40%;
    padding: 16px;
  }

  .ai-icon {
    height: 24px;
    width: 24px;
  }
}
</style>
